var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAvalanche16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fill: "#e84142",
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m141.573 74.878c.22-.431.576-.431.8 0l1.372 2.73c.22.431.04.783-.4.783h-2.765c-.436 0-.616-.352-.4-.783zm-2.655-5.255c.22-.431.571-.431.791 0l.306.624.721 1.436a1.671 1.671 0 0 1 0 1.3l-2.419 4.75a1.254 1.254 0 0 1 -.992.658h-2.008c-.441 0-.621-.346-.4-.783z",
    fill: "#fff",
    transform: "translate(-131.328 -66.705)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvalanche16);
export default __webpack_public_path__ + "static/media/ic_avalanche_16.90aca01d509bd5c078897016e2131828.svg";
export { ForwardRef as ReactComponent };